/**
 * Initialize mobile navigation on the document
 *
 */

export default function mobileNavInit() {
  const openButtonElement = document.querySelector('.js-mobile-nav-opener')
  const el = document.querySelector('.js-mobile-nav')
  const opener = document.querySelectorAll('.js-mobile-nav-level-opener')
  const back = document.querySelectorAll('.js-mobile-nav-back')

  if (el) {
    openButtonElement.addEventListener('click', (e) => {
      e.preventDefault()
      document.body.classList.toggle('mobile-nav-open')
    })

    opener.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        btn.closest('.navigation__item').querySelector('.js-mobile-nav-level').classList.add('open')
      })
    })

    back.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        btn.closest('.js-mobile-nav-level').classList.remove('open')
      })
    })
  }
}
